// extracted by mini-css-extract-plugin
export default {"container":"Workspace_container__z6Nxh","button":"Workspace_button__F6kBE","hsgbutton":"Workspace_hsgbutton__Ah7js","largeTile":"Workspace_largeTile__KSM6O"};